// extracted by css-extract-rspack-plugin
export default {"component":"Image-module__component___rUpGw"};